import "@mantine/core/styles.css";
import { MantineProvider, createTheme } from "@mantine/core";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Skills } from "./components/Skills";
import { Portfolio } from "./components/Portfolio";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import portfolioData from "./data/portfolio.json";
import "./App.css";

const theme = createTheme({
    colorScheme: "dark",
    primaryColor: "blue",
    defaultRadius: "md",
    fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    headings: {
        fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontWeight: 700,
    },
});

function App() {
    return (
        <MantineProvider theme={theme} defaultColorScheme='dark'>
            <div className='App'>
                <Hero data={portfolioData} />
                <About data={portfolioData} />
                <Skills data={portfolioData} />
                <Portfolio data={portfolioData} />
                <Contact data={portfolioData} />
                <Footer data={portfolioData} />
            </div>
        </MantineProvider>
    );
}

export default App;
